import React from 'react';
import { MRT_Row } from '@talentmesh/table';
import { TypographySmall } from '@/Components/shadcn';
import { TeamMember } from '@/Models/TeamMember';

interface RoleProps {
    row: MRT_Row<TeamMember>;
}

function Role({ row }: RoleProps): React.JSX.Element {
    return <TypographySmall>{row.original.role}</TypographySmall>;
}

export default Role;
